import { useChangePasswordForm } from "@/features/accountSettings/hooks";
import { AccountSettingsPresenter } from "@/features/accountSettings/presenter";

export const AccountSettingsContainer: React.FC = () => {
  const { form, handleSubmit } = useChangePasswordForm();

  return <AccountSettingsPresenter form={form} handleSubmit={handleSubmit} />;
};
